import {useEffect, useState} from 'react'
import blueLeftChevron from '../media/blue_left-chevron_icon.svg'
import blueRightChevron from '../media/blue_right-chevron_icon.svg'
import '../styles/Pagination.css'

export const Pagination = (props: any) => {
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage] = useState(props.items)

  const [pageNumberLimit] = useState(5)
  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5)
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0)

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage

  const currentItems = props.data.slice(indexOfFirstItem, indexOfLastItem)

  const pages = []
  for (let i = 1; i <= Math.ceil(props.data.length / itemsPerPage); i++) {
    pages.push(i)
  }

  useEffect(() => {
    if (props.data.length !== 0) {
      props.state(currentItems)
      setCurrentPage(1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data])

  useEffect(() => {
    props.state(currentItems)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage])

  const handleNavegation = (e: any) => {
    setCurrentPage(Number(e.target.id))
  }

  const handlePrevBtn = () => {
    setCurrentPage(currentPage - 1)
    if ((currentPage - 1) % pageNumberLimit === 0) {
      setMaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit)
      setMinPageNumberLimit(minPageNumberLimit - pageNumberLimit)
    }
  }

  const handleNextBtn = () => {
    setCurrentPage(currentPage + 1)
    if (currentPage + 1 > maxPageNumberLimit) {
      setMaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit)
      setMinPageNumberLimit(minPageNumberLimit + pageNumberLimit)
    }
  }

  return (
    <>
      {props.data.length !== 0 && (
        <div className='pages' style={{marginBottom:'10px'}}>
          {/* {!(currentPage === pages[0]) && ( */}
            <button onClick={handlePrevBtn} className='page page-auto w-inline-block btn-transparent' disabled={currentPage === pages[0]}>
              <img src={blueLeftChevron} loading='lazy' alt='' />
              <div>Anterior</div>
            </button>
          {/* )} */}

          {minPageNumberLimit >= 1 && (
            <button onClick={handlePrevBtn} className='page btn-transparent'>
              &hellip;
            </button>
          )}

          {pages.map((number: number) =>
            number < maxPageNumberLimit + 1 && number > minPageNumberLimit ? (
              <button
                onClick={handleNavegation}
                key={number}
                id={String(number)}
                className={`page btn-transparent ${
                  currentPage === number && 'page-active disable-hover'
                }`}
              >
                {number}
              </button>
            ) : null
          )}

          {pages.length > maxPageNumberLimit && (
            <button onClick={handleNextBtn} className='page btn-transparent'>
              &hellip;
            </button>
          )}

          {/* {!(currentPage === pages[pages.length - 1]) && ( */}
            <button onClick={handleNextBtn} className='page page-auto w-inline-block btn-transparent' disabled={currentPage === pages[pages.length - 1]}>
              <div>Siguiente</div>
              <img src={blueRightChevron} loading='lazy' alt='' />
            </button>
          {/* )} */}
        </div>
      )}
    </>
  )
}
